import { Tabs, Tab } from '../../components';
import { OutboundCall } from './outbound-call/OutboundCall';
import { GoogleConnect } from './google-connect/GoogleConnect';
import { PERMISSIONS } from '../../shared/constants/permissions';

type TabsEnum = 'outbound-call' | 'google-connect';

const CallManagementPage = () => {
  return (
    <>
      <Tabs<TabsEnum>
        tabs={[
          {
            name: 'outbound-call',
            label: 'Outbound Call',
            action: PERMISSIONS.MAKE_CALL,
          },
          {
            name: 'google-connect',
            label: 'Conference Call',
            action: PERMISSIONS.MAKE_CONFERENCE_CALL,
          },
        ]}
        contentClassName="mt-md"
      >
        <Tab name="outbound-call">
          <OutboundCall />
        </Tab>
        <Tab name="google-connect">
          <GoogleConnect />
        </Tab>
      </Tabs>
    </>
  );
};

export default CallManagementPage;
